import React from 'react';
import { FormControl } from '@mui/material';

const DSFormControl = (props: React.ComponentProps<typeof FormControl>) => {
  return <FormControl {...props} />;
};

export default DSFormControl;
